import React from 'react'
import PropTypes from "prop-types";
import { PureComponent } from "react";

import "./index.css";

class Tags extends PureComponent {
  static propTypes = {
    tags: PropTypes.array,
    onTagRemove: PropTypes.func,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    texts: PropTypes.object,
    children: PropTypes.node,
  };

  render() {
    const {
      tags,
      onTagRemove,
      texts = {},
      disabled,
      readOnly,
      children,
    } = this.props;
    let label = "Select Plans & SR Numbers";
    let hasAll = false;

    let cnt = 0;

    if (tags && tags.length > 0) {
      tags.map((tag) => {
        const { _id, type, value, tagClassName, dataset, tagLabel } = tag;
        if (value === "selectAll2") {
          label = "All Plans & SR Numbers";
          hasAll = true;
        } else {
          label = tags.length + " Selections";
          if (type != "header") {
            cnt++;
          }
        }
      });

      if (hasAll) {
        label = "All Plans & SR Numbers";
      } else if (cnt > 0) {
        label = cnt + " Selections";
      }
    }
    const lastItem = <span className="placeholder">{label}</span>;

    return (
      <ul className="tag-list" style={{ minWidth: "200px" }}>
        <li className="tag-item">{lastItem}</li>
      </ul>
    );
  }
}

export default Tags;
